import React from 'react';
import CheckBoxRender from './CheckBoxRender';
import {InputProps} from '../../../interfaces';

export const CheckBox = ({...props}:InputProps):JSX.Element=>{
	return <CheckBoxRender {...props}/>;
};
